/* eslint-disable jsx-a11y/label-has-associated-control */
import React from "react";
import cx from "classnames";

import styles from "./Switch.module.scss";

const Switch = ({ isOn, label = "", handleToggle, colorOne, colorTwo, id }) => (
  <>
    <input
      checked={isOn}
      onChange={handleToggle}
      className={styles.switchCheckbox}
      id={id}
      type="checkbox"
    />
    <label
      style={{ background: isOn ? colorOne : colorTwo }}
      className={cx(styles.switchLabel, {
        [styles.switchOn]: isOn,
        [styles.switchOff]: !isOn,
      })}
      htmlFor={id}
    >
      <span
        className={cx(styles.switchButton, {
          [styles.switchOn]: isOn,
          [styles.switchOff]: !isOn,
        })}
      />
      {label !== "" && <span className={styles.label}>{label}</span>}
    </label>
  </>
);

export default Switch;
